import { render, staticRenderFns } from "./PickerOrderInvalidAccess.vue?vue&type=template&id=4a97ee10&scoped=true&"
import script from "./PickerOrderInvalidAccess.vue?vue&type=script&lang=ts&"
export * from "./PickerOrderInvalidAccess.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a97ee10",
  null
  
)

export default component.exports